import { FCX, ID } from "@datassential/platform-ui-lib";
import cn from "classnames";

interface MacsListMoreLabelProps {
    rowId: ID;
    count: number;
    isHighlighted: boolean;
}

const MacsListMoreLabel: FCX<MacsListMoreLabelProps> = ({ rowId, count, isHighlighted }) => (
    <span
        className={cn("MacsList__more-label", { "is-highlighted": isHighlighted })}
        data-tooltip-id={`macs-list-table-item-description-${rowId}`}
    >
        {`and ${count} more`}
    </span>
);

export default MacsListMoreLabel;
